module.exports = __webpack_public_path__ + "static/media/AboutSouthAsiaConsultancy.496b7d75.webp";